export default __webpack_public_path__ + "static/media/mike.ba6f8b58.png";